import styled from "styled-components";

/** The wallets under the card's drawing. */
export const WalletsPart = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;
  font-family: Inter, sans-serif;
`;

/** Side by side while they fit (one under the other on a narrow phone). */
export const WalletButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
`;

/** A wallet: black, as the wallets' own buttons, with the wallet's colors in its drawing. */
export const WalletButton = styled.button`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  min-height: 52px;
  padding: 0.5rem 1.125rem;
  border: 0;
  border-radius: 12px;
  background: #000;
  color: #fff;
  font-family: Inter, sans-serif;
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.125rem;
  text-align: left;
  cursor: pointer;
  transition: transform 0.15s;

  &:hover:not([aria-disabled="true"]) {
    transform: translateY(-1px);
  }

  svg {
    flex: none;
  }

  > span {
    display: flex;
    flex-direction: column;
    white-space: nowrap;
  }

  small {
    font-size: 0.6875rem;
    font-weight: 500;
    opacity: 0.8;
  }

  &[aria-disabled="true"] {
    cursor: not-allowed;
    opacity: 0.55;
  }

  &[aria-busy="true"] {
    opacity: 0.7;
  }
`;
